import script from "./MfEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./MfEmpty.vue?vue&type=script&setup=true&lang=js"

import "./MfEmpty.vue?vue&type=style&index=0&id=62e00ae8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e00ae8"]])

export default __exports__